import React from 'react';
import * as R from 'unitx/ramda';
import wrapComponent from "../../core/wrapComponent";
import ItemRender from "./ItemRender";
const DEFAULT_PATH = [];

const DEFAULT_KEY_EXTRACTOR = (_, index) => `${index}`;

function DataRender(props) {
  const {
    accessor,
    data,
    renderItem,
    renderChildren,
    extraData,
    keyExtractor = DEFAULT_KEY_EXTRACTOR
  } = props;
  const defaultRenderChildren = React.useCallback(({
    parentItem,
    data: childData,
    level,
    accessor: overrideAccessor,
    path,
    defaultRenderChildren: itemDefaultRenderChildren
  }) => {
    var _ref;

    const currentAccessor = overrideAccessor !== null && overrideAccessor !== void 0 ? overrideAccessor : accessor;
    return R.mapIndexed((item, index) => /*#__PURE__*/React.createElement(ItemRender, {
      key: keyExtractor(item, index),
      defaultRenderChildren: itemDefaultRenderChildren,
      accessor: currentAccessor,
      extraData: extraData,
      item: item,
      level: level,
      parentItem: parentItem,
      path: path,
      renderItem: renderItem,
      renderChildren: renderChildren
    }))((_ref = childData !== null && childData !== void 0 ? childData : R.path(currentAccessor)(parentItem)) !== null && _ref !== void 0 ? _ref : []);
  }, [accessor, extraData]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, defaultRenderChildren({
    // @ts-ignore
    parentItem: null,
    data,
    level: 0,
    path: DEFAULT_PATH,
    accessor,
    defaultRenderChildren
  }));
}

export default wrapComponent(DataRender, {
  isEqual: R.equalsExclude(R.isFunction)
});
export { RenderChildrenProps, ItemRenderProps } from "./ItemRender";